import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";
// @material-ui/core components
import { withStyles, makeStyles } from "@material-ui/core/styles";
import Checkbox from "@material-ui/core/Checkbox";
import Tooltip from "@material-ui/core/Tooltip";
import IconButton from "@material-ui/core/IconButton";
import Table from "@material-ui/core/Table";
import TableRow from "@material-ui/core/TableRow";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
// @material-ui/icons
import Slider from "@material-ui/core/Slider";
import Edit from "@material-ui/icons/Edit";
import Close from "@material-ui/icons/Close";
import Check from "@material-ui/icons/Check";
import Avatar from "@material-ui/core/Avatar";
import AvatarGroup from "@material-ui/lab/AvatarGroup";
import imageavatar1 from "assets/img/faces/vn1.jpg";
import imageavatar2 from "assets/img/faces/vn2.jpg";
import imageavatar3 from "assets/img/faces/vn3.jpg";
// core components
import styles from "assets/jss/material-dashboard-react/components/tasksStyle.js";

const useStyles = makeStyles(styles);
const useAvatarStyles = makeStyles((theme) => ({
  ava: {
    display: "flex",
    "& > *": {
      margin: theme.spacing(1),
    },
  },
  root: {
    width: 100 + theme.spacing(3) * 2,
  },
  margin: {
    height: theme.spacing(3),
  },
}));

const PrettoSlider = withStyles({
  root: {
    color: "#52af77",
    height: 8,
  },
  thumb: {
    height: 36,
    width: 36,
    backgroundColor: "#fff",
    border: "2px solid currentColor",
    marginTop: -8,
    marginLeft: -12,
    "&:focus, &:hover, &$active": {
      boxShadow: "inherit",
    },
  },
  active: {},
  valueLabel: {
    left: "calc(-50% + 16px)",
  },
  track: {
    height: 18,
    borderRadius: 8,
  },
  rail: {
    height: 18,
    borderRadius: 8,
  },
})(Slider);

export default function Tasks(props) {
  const classes = useStyles();
  const classes1 = useAvatarStyles();
  const [checked, setChecked] = React.useState([...props.checkedIndexes]);
  const handleToggle = (value) => {
    const currentIndex = checked.indexOf(value);
    const newChecked = [...checked];
    if (currentIndex === -1) {
      newChecked.push(value);
    } else {
      newChecked.splice(currentIndex, 1);
    }
    setChecked(newChecked);
  };
  const { tasksIndexes, tasks, rtlActive } = props;
  const tableCellClasses = classnames(classes.tableCell, {
    [classes.tableCellRTL]: rtlActive,
  });
  return (
    <Table className={classes.table}>
      <TableBody>
        {tasksIndexes.map((value) => (
          <TableRow key={value} className={classes.tableRow}>
            <TableCell className={tableCellClasses}>
              <Checkbox
                checked={checked.indexOf(value) !== -1}
                tabIndex={-1}
                onClick={() => handleToggle(value)}
                checkedIcon={<Check className={classes.checkedIcon} />}
                icon={<Check className={classes.uncheckedIcon} />}
                classes={{
                  checked: classes.checked,
                  root: classes.root,
                }}
              />
            </TableCell>
            <TableCell className={tableCellClasses} padding="none" scope="row">
              {tasks[value]}
            </TableCell>
            <TableCell
              className={tableCellClasses}
              padding="default"
              align="right"
            >
              <div className={classes1.root}>
                <PrettoSlider
                  valueLabelDisplay="auto"
                  aria-label="pretto slider"
                  defaultValue={50}
                />
              </div>
            </TableCell>
            <TableCell
              className={tableCellClasses}
              padding="default"
              align="right"
            >
              <div className={classes1.ava}>
                <Avatar alt="Remy Sharp" src={imageavatar1} />
              </div>
            </TableCell>
            <TableCell
              className={tableCellClasses}
              padding="default"
              align="right"
            >
              <AvatarGroup max={4}>
                <Avatar alt="Remy Sharp" src={imageavatar1} />
                <Avatar alt="Travis Howard" src={imageavatar2} />
                <Avatar alt="Cindy Baker" src={imageavatar3} />
                <Avatar alt="Cindy Baker" src={imageavatar3} />
                <Avatar alt="Cindy Baker" src={imageavatar3} />
              </AvatarGroup>
            </TableCell>
            <TableCell
              className={classes.tableActions}
              padding="default"
              align="right"
            >
              <Tooltip
                id="tooltip-top"
                title="Edit Task"
                placement="top"
                classes={{ tooltip: classes.tooltip }}
              >
                <IconButton
                  aria-label="Edit"
                  className={classes.tableActionButton}
                >
                  <Edit
                    className={
                      classes.tableActionButtonIcon + " " + classes.edit
                    }
                  />
                </IconButton>
              </Tooltip>
              <Tooltip
                id="tooltip-top-start"
                title="Remove"
                placement="top"
                classes={{ tooltip: classes.tooltip }}
              >
                <IconButton
                  aria-label="Close"
                  className={classes.tableActionButton}
                >
                  <Close
                    className={
                      classes.tableActionButtonIcon + " " + classes.close
                    }
                  />
                </IconButton>
              </Tooltip>
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
}

Tasks.propTypes = {
  tasksIndexes: PropTypes.arrayOf(PropTypes.number),
  tasks: PropTypes.arrayOf(PropTypes.node),
  rtlActive: PropTypes.bool,
  checkedIndexes: PropTypes.array,
};
